// libs
import React, { memo } from 'react';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

// styles
import { Container, DropDownButton, DropDownIcon } from './styles';

// defs
interface ICollapsibleExapnder {
  isExpanded: boolean;
}

function CollapsibleExpander({ isExpanded }: ICollapsibleExapnder) {
  const ChevronDownIcon = useStoreIcon(IconName.CHEVRON_DOWN_SMALL);
  return (
    <Container>
      <DropDownButton>
        <DropDownIcon as={ChevronDownIcon} showCollapsible={isExpanded} />
      </DropDownButton>
    </Container>
  );
}

export default memo(CollapsibleExpander);
